<template>
  <div class="game-input-on-background-wrapper">
    <div class="tab-container">
      <div class="row-container first-row">
        <div class="cell-container" v-for="(cell, index) in firstRow" :key="'cellFirst_' + index">
          <div class="cell">{{ cell.text }}</div>
        </div>
      </div>
      <div class="row-container second-row">
        <div class="cell-container" v-for="(item, index) in secondRow" :key="'cellSec_' + index">
          <div class="cell">
            <tr-input
              :key="item.id"
              :tr-input-value="secondRowInputData[index]"
              :input-width="startGameConfig.inputWidth"
              :input-height="startGameConfig.inputHeight"
            ></tr-input>
          </div>
        </div>
      </div>
      <div class="row-container third-row">
        <div class="cell-container" v-for="(item, index) in thirdRow" :key="'cellThird_' + index">
          <div class="cell">
            <tr-input
              :key="item.id"
              :tr-input-value="thirdRowInputData[index]"
              :input-width="startGameConfig.inputWidth"
              :input-height="startGameConfig.inputHeight"
            ></tr-input>
          </div>
        </div>
      </div>
      <div class="row-container forth-row">
        <div class="cell-container" v-for="(item, index) in forthRow" :key="'cellFourth_' + index">
          <div class="cell">
            <tr-input
              :key="item.id"
              :tr-input-value="forthRowInputData[index]"
              :input-width="startGameConfig.inputWidth"
              :input-height="startGameConfig.inputHeight"
            ></tr-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @namespace InputOnBackgroundWithoutCheck
 * @todo dopisać dokumentacje
 */

/**
 * Konfiguracja gier opartych na silniku inputOnBackground
 * @type {InputOnBackgroundWithoutCheckConfig}
 * @memberof InputOnBackgroundWithoutCheck
 * @name InputOnBackgroundWithoutCheckConfig
 *
 * @todo dopisać dokumentacje
 */
var config;

import _ from 'lodash';
import TrInput from '../TrInput/TrInput';
export default {
  name: 'tr-input-on-background-without-check',
  components: {
    TrInput,
  },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      firstRow: [
        { text: 'nazwa drzewa' },
        { text: 'kolor pnia' },
        { text: 'liscie (kształty) kolor,\nczy są symetryczne' },
        { text: 'rozmiar – duże, grube' },
      ],
      inputData: [],
    };
  },
  beforeMount() {
    this.inputData = _.map(this.startGameConfig.items, (item) => {
      return { val: '', block: false };
    });
    // this.longestWordLength = _.maxBy(this.inputData, (item) => {
    //   return item.correct.length;
    // });
    // console.log('  this.longestWordLength', this.longestWordLength.correct, this.longestWordLength.correct.length);
    // console.log('this.inputData', this.inputData);
  },
  mounted() {},
  methods: {
    /**
     * reset all containerEnd without reset reactivity
     * @memberof InputOnBackgroundWithoutCheck
     * @method resetGameAction
     */
    resetGameAction() {
      _.each(this.inputData, (item, key, collection) => {
        item.val = '';
      });
      // this.questionsList = this.processQuestionsList();
    },
    checkGameAction() {},
  },
  computed: {
    secondRow() {
      return _.slice(this.startGameConfig.items, 0, 4);
    },
    secondRowInputData() {
      return _.slice(this.inputData, 0, 4);
    },
    thirdRow() {
      return _.slice(this.startGameConfig.items, 4, 8);
    },
    thirdRowInputData() {
      return _.slice(this.inputData, 4, 8);
    },
    forthRow() {
      return _.slice(this.startGameConfig.items, 8, 12);
    },
    forthRowInputData() {
      return _.slice(this.inputData, 8, 12);
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
    /**
     * computed value to watch if game should be checkd
     * @method checkGame
     * @return {Boolean}  if true then performe check action
     */
    checkGame() {
      return this.$store.getters.checkGame;
    },
    /**
     * computed value to watch if game should be resetGame
     * @memberof InputOnBackgroundWithoutCheck
     * @method resetGameSwitch
     * @return {Boolean}  if true then performe reset action
     */
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/fonts';
.tab-container {
  position: absolute;
  top: 251px;
  left: 10px;
  width: 1900px;
  height: 563px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;

  .row-container {
    width: 1900px;
    height: 110px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    font-weight: bold;
    font-size: $gameBaseFontSize + -5px;
    margin-top: 5px;
    margin-bottom: 5px;
    .cell-container {
      display: flex;
      justify-content: center;
      align-items: center;
      // background-color: #ead13f;
      width: 565px;
      height: 110px;
      margin-right: 5px;
      margin-left: 5px;
    }
  }
  .first-row {
    .cell-container {
      background-color: #ead13f;
    }
  }
  .second-row {
    .cell-container {
      background-color: #ccf0ff;
    }
  }
  .third-row {
    .cell-container {
      background-color: #ace7ff;
    }
  }
  .forth-row {
    .cell-container {
      background-color: #ccf0ff;
    }
  }
}
// .game-input-on-background-wrapper {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     width: 100%;
//     height: 100%;
//
//     background-size: contain;
//     background-repeat: no-repeat;
//     // background-image: url("~@/assets/icons/book/toolbox/przybornik_kosz.png");
// }
</style>
